<app-section-header surtitle="Activités" title="Activités aux alentours"></app-section-header>

<div class="content-container">
    <div class="activities-grid">
        <div *ngFor="let activity of activities; let i = index" class="activity-card"
            appScrollReveal [revealDelay]="(i % 8) * 50">
            <div class="card-header-section">
                <mat-icon class="activity-icon">{{ activity.icon }}</mat-icon>
                <h3 class="card-title">{{ activity.name }}</h3>
            </div>
            <div class="card-body">
                <p>{{ activity.description }}</p>
                <div *ngIf="activity.phone" class="info-item">
                    <mat-icon>phone</mat-icon>
                    <span>{{ activity.phone }}</span>
                </div>
                <div *ngIf="activity.website" class="info-item">
                    <mat-icon>language</mat-icon>
                    <a [href]="activity.website" target="_blank" rel="noopener noreferrer" [attr.aria-label]="'Site web de ' + activity.name">Site web</a>
                </div>
                <div *ngIf="activity.address" class="info-item">
                    <mat-icon>location_on</mat-icon>
                    <span>{{ activity.address }}</span>
                </div>
            </div>
        </div>
    </div>
</div>
